import request from '@/utils/request'
import { getToken } from '@/utils/storage'

// 获取合同信息
export function getContractInfoApi(params) {
  let url = '/user/contract/getContract'
  if (getToken()) {
    url = '/user/contract/getContractInfo'
  }
  return request({
    url,
    method: 'get',
    params
  })
}

// 保存合同
export function submitContractApi(data) {
  return request({
    url: '/user/contract/submitContract',
    method: 'post',
    data
  })
}

// 文件上传
export function contractFileUploadApi(data) {
  return request({
    url: '/user/contract/fileUpload',
    method: 'post',
    data
  })
}

// 下载合同
export function getPdfApi(params) {
  return request({
    url: '/user/contract/getPdf',
    method: 'get',
    responseType: 'blob',
    params
  })
}
